export default __webpack_public_path__ + "static/media/logo.85ac7d99.png";